import React from "react";
import Link from "gatsby-link";
import ClassNames from "classnames";
import Client from "shopify-buy";

import Bus from "../../utils/bus";
let BUS = new Bus();

class NutritionalModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    if (window.location.hash === "#nutritional-facts") {
      this.setState({ open: true });
    }
    BUS.listen("OPEN_NUTRITIONAL", this.open);
  }

  componentWillUnmount() {
    BUS.stopListening("OPEN_NUTRITIONAL", this.open);
  }

  open() {
    this.setState({
      open: true
    });
  }

  close() {
    this.setState({
      open: false
    });
  }

  render() {
    let data = this.props.data;

    if (!this.state.open) {
      return null;
    }

    return (
      <div className="NutritionalModal">
        <div className="bg" onClick={this.close} />
        <a className="close" onClick={this.close}>
          <span>&times;</span>
        </a>
        <div className="image">
          <img src={data.fluid.src} />
        </div>
      </div>
    );
  }
}

export default NutritionalModal;



// WEBPACK FOOTER //
// ./src/components/page/nutritional-modal.js